/* assets/provider-report-jobs.js — PROVIDER-REPORT-JOBS-07 */
(function (window, document) {
  'use strict';

  var VERSION = 'PROVIDER-REPORT-JOBS-07';
  var GLOBAL_KEY = '__PROVIDER_REPORT_JOBS_RUNTIME__';
  var ROOT_SELECTOR = '[data-provider-report-jobs]';
  var REPORT_DRAFT_CONTRACT = 'provider_report_draft_v1';
  var API_ORIGIN = 'https://api.glhksolution.com';
  var API_PREFIX = '/v1/gcitypartners/';
  var draftCache = new Map();
  var saveTimers = new Map();

  if (window[GLOBAL_KEY] && typeof window[GLOBAL_KEY].mountAll === 'function') {
    window[GLOBAL_KEY].mountAll(document);
    return;
  }

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function isZh() {
    return clean(document.documentElement.lang).toLowerCase().indexOf('zh') === 0;
  }

  function copy() {
    return isZh()
      ? {
          emptyAvailable: '目前沒有可接工作。',
          emptyMine: '你目前沒有進行中的報告工作。',
          loadError: '暫時無法載入工作，請稍後再試。',
          detailError: '暫時無法載入工作詳情。',
          detailEmpty: '尚未提供',
          accept: '接下工作',
          accepting: '接單中…',
          assigned: '已接下',
          open: '打開工作',
          saving: '儲存中…',
          saved: '已儲存',
          notSaved: '尚未儲存',
          saveError: '未能儲存，請繼續編輯後重試。',
          locked: '這份報告已不可再編輯。',
          preview: '預覽報告',
          previewing: '正在建立預覽…',
          previewReady: '預覽已更新',
          previewError: '暫時無法建立預覽，請確認內容已儲存。',
          submit: '提交覆核',
          submitting: '提交中…',
          submitted: '已提交',
          submittedStatus: '已提交覆核，等待處理。',
          submitError: '暫時未能提交，請確認報告後重試。',
          summaryRequired: '請先填寫摘要，再重新預覽。',
          statusAssigned: '已分配',
          statusReview: '覆核中',
          statusCompleted: '已完成',
          statusOther: '處理中'
        }
      : {
          emptyAvailable: 'No report work is available right now.',
          emptyMine: 'You do not have active report work yet.',
          loadError: 'Work could not be loaded. Try again shortly.',
          detailError: 'Work details could not be loaded.',
          detailEmpty: 'Not provided yet',
          accept: 'Accept work',
          accepting: 'Accepting…',
          assigned: 'Accepted',
          open: 'Open work',
          saving: 'Saving…',
          saved: 'Saved',
          notSaved: 'Not saved yet',
          saveError: 'Could not save. Continue editing to retry.',
          locked: 'This report is no longer editable.',
          preview: 'Preview report',
          previewing: 'Building preview…',
          previewReady: 'Preview updated',
          previewError: 'Preview could not be built. Make sure the draft is saved.',
          submit: 'Submit for review',
          submitting: 'Submitting…',
          submitted: 'Submitted',
          submittedStatus: 'Submitted for review and waiting to be processed.',
          submitError: 'The report could not be submitted. Check it and try again.',
          summaryRequired: 'Add the summary, then preview the report again.',
          statusAssigned: 'Assigned',
          statusReview: 'In review',
          statusCompleted: 'Completed',
          statusOther: 'In progress'
        };
  }

  function statusLabel(status) {
    var labels = copy();
    var value = clean(status).toLowerCase();
    if (value === 'assigned') return labels.statusAssigned;
    if (value === 'in_review') return labels.statusReview;
    if (value === 'completed') return labels.statusCompleted;
    return labels.statusOther;
  }

  function nativeSession() {
    var session = window.LittleGWebSession;
    return session && typeof session.authenticatedFetch === 'function' ? session : null;
  }

  function nativeReady() {
    var session = nativeSession();
    if (!session || typeof session.getState !== 'function') return false;
    var state = session.getState();
    return Boolean(state && state.status === 'authenticated' && state.profile && clean(state.profile.id));
  }

  function trustedEndpoint(url) {
    try {
      var parsed = new URL(clean(url), API_ORIGIN);
      return parsed.origin === API_ORIGIN && parsed.pathname.indexOf(API_PREFIX) === 0;
    } catch (_error) {
      return false;
    }
  }

  function requestJson(url, options) {
    var session = nativeSession();
    if (!session || !trustedEndpoint(url)) return Promise.reject(new Error('native_session_unavailable'));
    return session.authenticatedFetch(url, Object.assign({
      headers: { 'Accept': 'application/json' }
    }, options || {})).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || !data || data.ok !== true) {
          var error = new Error(clean(data && data.message) || 'request_failed');
          error.status = response.status;
          error.code = clean(data && data.error);
          throw error;
        }
        return data;
      });
    });
  }

  function makeText(tag, className, value) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    node.textContent = clean(value);
    return node;
  }

  function formatProduct(handle) {
    return clean(handle).replace(/[-_]+/g, ' ').replace(/\b\w/g, function (letter) {
      return letter.toUpperCase();
    }) || 'Report';
  }

  function formatDeadline(value) {
    var raw = clean(value);
    if (!raw) return copy().detailEmpty;
    var date = new Date(raw);
    if (Number.isNaN(date.getTime())) return raw;
    try {
      return new Intl.DateTimeFormat(isZh() ? 'zh-HK' : 'en-HK', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(date);
    } catch (_error) {
      return raw;
    }
  }

  function humanLabel(key) {
    var raw = clean(key).toLowerCase();
    var labels = {
      address: isZh() ? '地址' : 'Address',
      place_label: isZh() ? '地點' : 'Place',
      property_type: isZh() ? '物業類型' : 'Property type',
      purpose: isZh() ? '用途' : 'Purpose',
      requirement: isZh() ? '需要' : 'Requirement',
      source: isZh() ? '來源' : 'Source',
      source_name: isZh() ? '來源' : 'Source',
      as_of: isZh() ? '資料日期' : 'As of',
      checked_on: isZh() ? '檢查日期' : 'Checked on',
      reason: isZh() ? '原因' : 'Why it matters',
      label: isZh() ? '項目' : 'Item',
      name: isZh() ? '名稱' : 'Name',
      value: isZh() ? '內容' : 'Value'
    };
    if (labels[raw]) return labels[raw];
    return raw.replace(/[_-]+/g, ' ').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function isPrivateKey(key) {
    return /(^|_)(id|token|secret)$|customer|provider|authorization|auth_/i.test(clean(key));
  }

  function scalarText(value) {
    if (value == null || value === '') return '';
    if (typeof value === 'boolean') return value ? (isZh() ? '是' : 'Yes') : (isZh() ? '否' : 'No');
    if (typeof value === 'number') return String(value);
    if (typeof value === 'string') return clean(value);
    return '';
  }

  function summarizeObject(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return scalarText(value);
    var preferred = ['label', 'name', 'address', 'place_label', 'source_name', 'source', 'reason', 'value'];
    for (var index = 0; index < preferred.length; index += 1) {
      var text = scalarText(value[preferred[index]]);
      if (text) return text;
    }
    var parts = Object.keys(value).filter(function (key) {
      return !isPrivateKey(key);
    }).map(function (key) {
      return scalarText(value[key]);
    }).filter(Boolean);
    return parts.slice(0, 3).join(' · ');
  }

  function renderDetailValue(target, value) {
    if (!target) return;
    target.replaceChildren();
    var empty = copy().detailEmpty;
    var scalar = scalarText(value);
    if (scalar) {
      target.appendChild(makeText('p', 'provider-job-detail__value', scalar));
      return;
    }
    if (Array.isArray(value)) {
      if (!value.length) {
        target.appendChild(makeText('p', 'provider-job-detail__empty', empty));
        return;
      }
      var list = document.createElement('ul');
      list.className = 'provider-job-detail__list';
      value.forEach(function (item) {
        var text = summarizeObject(item) || scalarText(item);
        if (text) list.appendChild(makeText('li', '', text));
      });
      if (list.children.length) target.appendChild(list);
      else target.appendChild(makeText('p', 'provider-job-detail__empty', empty));
      return;
    }
    if (value && typeof value === 'object') {
      var entries = Object.keys(value).filter(function (key) {
        return !isPrivateKey(key) && (scalarText(value[key]) || Array.isArray(value[key]));
      });
      if (!entries.length) {
        target.appendChild(makeText('p', 'provider-job-detail__empty', empty));
        return;
      }
      var listNode = document.createElement('dl');
      listNode.className = 'provider-job-detail__facts';
      entries.forEach(function (key) {
        var raw = value[key];
        var detail = Array.isArray(raw)
          ? raw.map(function (item) { return summarizeObject(item) || scalarText(item); }).filter(Boolean).join(' · ')
          : scalarText(raw);
        if (!detail) return;
        listNode.appendChild(makeText('dt', '', humanLabel(key)));
        listNode.appendChild(makeText('dd', '', detail));
      });
      if (listNode.children.length) target.appendChild(listNode);
      else target.appendChild(makeText('p', 'provider-job-detail__empty', empty));
      return;
    }
    target.appendChild(makeText('p', 'provider-job-detail__empty', empty));
  }

  function lineItems(value) {
    var seen = new Set();
    return String(value == null ? '' : value).split(/\r?\n/).map(clean).filter(function (item) {
      if (!item || seen.has(item)) return false;
      seen.add(item);
      return true;
    }).slice(0, 50).map(function (item) { return item.slice(0, 500); });
  }

  function blankDraft() {
    return {
      contract: REPORT_DRAFT_CONTRACT,
      sections: { summary: '', verified_items: [], missing_items: [], next_steps: [] }
    };
  }

  function buildDraft(editor) {
    if (!editor) return blankDraft();
    function field(name) {
      return editor.querySelector('[data-provider-report-field="' + name + '"]');
    }
    var summary = field('summary');
    var verified = field('verified_items');
    var missing = field('missing_items');
    var next = field('next_steps');
    return {
      contract: REPORT_DRAFT_CONTRACT,
      sections: {
        summary: clean(summary && summary.value).slice(0, 2000),
        verified_items: lineItems(verified && verified.value),
        missing_items: lineItems(missing && missing.value),
        next_steps: lineItems(next && next.value)
      }
    };
  }

  function applyDraft(editor, draft) {
    if (!editor) return;
    var source = draft && draft.sections ? draft.sections : blankDraft().sections;
    function set(name, value) {
      var field = editor.querySelector('[data-provider-report-field="' + name + '"]');
      if (field) field.value = Array.isArray(value) ? value.join('\n') : clean(value);
    }
    set('summary', source.summary);
    set('verified_items', source.verified_items);
    set('missing_items', source.missing_items);
    set('next_steps', source.next_steps);
  }

  function editorStatus(editor, state, message) {
    if (!editor) return;
    editor.setAttribute('data-provider-report-save-state', state);
    var target = editor.querySelector('[data-provider-report-save-status]');
    if (target) target.textContent = clean(message);
  }

  function setEditorLocked(editor, locked) {
    if (!editor) return;
    editor.setAttribute('data-provider-report-editor-locked', locked ? 'true' : 'false');
    Array.prototype.forEach.call(editor.querySelectorAll('[data-provider-report-field]'), function (field) {
      field.disabled = locked;
    });
    if (locked) editorStatus(editor, 'locked', copy().locked);
  }

  function hydrateEditor(editor, jobId, jobStatus) {
    if (!editor) return;
    var key = clean(jobId);
    var status = clean(jobStatus);
    editor.setAttribute('data-provider-report-job-id', key);
    editor.setAttribute('data-provider-report-job-status', status);
    editor.setAttribute('data-provider-report-draft-version', '0');
    applyDraft(editor, draftCache.get(key) || blankDraft());
    editor.setAttribute('data-provider-report-editor-state', draftCache.has(key) ? 'editing' : 'blank');
    setEditorLocked(editor, status !== 'assigned');
    if (status === 'assigned') editorStatus(editor, 'idle', copy().notSaved);
  }

  function captureEditor(editor) {
    if (!editor || editor.getAttribute('data-provider-report-editor-locked') === 'true') return null;
    var jobId = clean(editor.getAttribute('data-provider-report-job-id'));
    if (!jobId) return null;
    var draft = buildDraft(editor);
    draftCache.set(jobId, draft);
    editor.setAttribute('data-provider-report-editor-state', 'editing');
    return draft;
  }

  function renderEmpty(list, message) {
    list.replaceChildren(makeText('p', 'provider-report-jobs__empty', message));
  }

  function renderAvailable(root, items) {
    var list = root.querySelector('[data-provider-job-list="available"]');
    if (!list) return;
    var labels = copy();
    if (!Array.isArray(items) || !items.length) {
      renderEmpty(list, labels.emptyAvailable);
      return;
    }
    var fragment = document.createDocumentFragment();
    items.forEach(function (job) {
      var card = document.createElement('article');
      card.className = 'provider-report-jobs__card';
      card.setAttribute('data-provider-job-card', clean(job.job_id));
      var copyWrap = document.createElement('div');
      copyWrap.className = 'provider-report-jobs__card-copy';
      copyWrap.appendChild(makeText('strong', 'provider-report-jobs__title', formatProduct(job.product_handle)));
      copyWrap.appendChild(makeText('span', 'provider-report-jobs__meta', clean(job.delivery_method || 'Report')));
      card.appendChild(copyWrap);
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'portal-button portal-button--primary provider-report-jobs__accept';
      button.setAttribute('data-provider-job-accept', clean(job.job_id));
      const jobId = clean(job.job_id);
      const pending = pendingAcceptJobs.has(jobId);
      const uncertain = uncertainAcceptJobs.has(jobId);

      button.disabled = pending || uncertain;
      button.setAttribute('aria-busy', String(pending));

      button.textContent = pending
        ? labels.accepting
        : uncertain
          ? jobListMessage('接案結果待確認', 'Acceptance unconfirmed')
          : labels.accept;

      card.appendChild(button);
      fragment.appendChild(card);
    });
    list.replaceChildren(fragment);
  }

  function renderMine(root, items) {
    var list = root.querySelector('[data-provider-job-list="mine"]');
    if (!list) return;
    var labels = copy();
    if (!Array.isArray(items) || !items.length) {
      renderEmpty(list, labels.emptyMine);
      return;
    }
    var fragment = document.createDocumentFragment();
    items.forEach(function (job) {
      var card = document.createElement('article');
      card.className = 'provider-report-jobs__card provider-report-jobs__card--mine';
      card.setAttribute('data-provider-job-card', clean(job.job_id));
      var copyWrap = document.createElement('div');
      copyWrap.className = 'provider-report-jobs__card-copy';
      copyWrap.appendChild(makeText('strong', 'provider-report-jobs__title', formatProduct(job.product_handle)));
      copyWrap.appendChild(makeText('span', 'provider-report-jobs__meta', statusLabel(job.status)));
      card.appendChild(copyWrap);
      var actions = document.createElement('div');
      actions.className = 'provider-report-jobs__card-actions';
      var badge = makeText('span', 'provider-report-jobs__status', statusLabel(job.status));
      badge.setAttribute('data-provider-job-status', clean(job.status));
      actions.appendChild(badge);
      var open = document.createElement('button');
      open.type = 'button';
      open.className = 'portal-button provider-report-jobs__open';
      open.setAttribute('data-provider-job-open', clean(job.job_id));
      open.textContent = labels.open;
      actions.appendChild(open);
      card.appendChild(actions);
      fragment.appendChild(card);
    });
    list.replaceChildren(fragment);
  }

  function setState(root, state, message) {
    root.setAttribute('data-provider-jobs-state', state);
    var target = root.querySelector('[data-provider-jobs-message]');
    if (target) target.textContent = clean(message);
  }

  function endpoints(root) {
    return {
      available: clean(root.getAttribute('data-provider-jobs-available-endpoint')),
      mine: clean(root.getAttribute('data-provider-jobs-mine-endpoint')),
      accept: clean(root.getAttribute('data-provider-jobs-accept-endpoint')),
      detail: clean(root.getAttribute('data-provider-jobs-detail-endpoint')),
      draft: clean(root.getAttribute('data-provider-jobs-draft-endpoint')),
      preview: clean(root.getAttribute('data-provider-jobs-preview-endpoint')),
      submit: clean(root.getAttribute('data-provider-jobs-submit-endpoint'))
    };
  }

  const jobListVersions = new WeakMap();

  function jobListMessage(zh, en) {
    return isZh() ? zh : en;
  }

  function clearJobLists(root, message) {
    root.querySelectorAll('[data-provider-job-list]').forEach((node) => {
      node.replaceChildren(
        makeText('p', 'provider-report-jobs__empty', message)
      );
    });
  }

  function setJobListState(root, state, message) {
    root.setAttribute('data-provider-job-lists-state', state);
    setState(root, state, message);

    root.querySelectorAll('[data-provider-job-list]').forEach((node) => {
      node.setAttribute('aria-busy', String(state === 'loading'));
    });

    const retry = root.querySelector('[data-provider-jobs-retry]');

    if (retry) {
      retry.disabled = state === 'loading';
      retry.textContent = state === 'loading'
        ? jobListMessage('正在載入…', 'Loading…')
        : jobListMessage('重新載入工作', 'Reload work');
    }
  }

  function validJobListResponse(response) {
    return Boolean(
      response &&
      response.ok === true &&
      Array.isArray(response.items) &&
      response.items.every((item) => (
        item &&
        typeof item === 'object' &&
        !Array.isArray(item) &&
        typeof item.job_id === 'string' &&
        item.job_id.trim().length > 0
      ))
    );
  }

  function resetJobLists(root, state, message) {
    jobListVersions.set(
      root,
      (jobListVersions.get(root) || 0) + 1
    );

    clearJobLists(root, message);
    setJobListState(root, state, message);
  }

  async function load(root) {
    const version = (jobListVersions.get(root) || 0) + 1;
    jobListVersions.set(root, version);

    const session = nativeSession();
    const current = session && typeof session.getState === 'function'
      ? session.getState()
      : null;

    const principalId = (
      current &&
      current.profile &&
      typeof current.profile.id === 'string'
    ) ? current.profile.id.trim() : '';

    if (!session || typeof session.getState !== 'function') {
      const message = jobListMessage(
        '登入服務尚未就緒，請稍後重試。',
        'The sign-in service is not ready. Retry shortly.'
      );

      clearJobLists(root, message);
      setJobListState(root, 'not_connected', message);
      return;
    }

    if (
      !current ||
      current.status !== 'authenticated' ||
      !principalId
    ) {
      const message = jobListMessage(
        '請登入並確認 Provider 存取權限。',
        'Sign in and confirm Provider access.'
      );

      clearJobLists(root, message);
      setJobListState(root, 'unauthorized', message);
      return;
    }

    const api = endpoints(root);

    if (
      !api.available ||
      !api.mine ||
      !trustedEndpoint(api.available) ||
      !trustedEndpoint(api.mine)
    ) {
      const message = jobListMessage(
        '工作列表服務未連接，請聯絡支援。',
        'The work list service is not connected. Contact support.'
      );

      clearJobLists(root, message);
      setJobListState(root, 'not_connected', message);
      return;
    }

    const isCurrent = () => {
      if (
        !root.isConnected ||
        jobListVersions.get(root) !== version ||
        nativeSession() !== session
      ) {
        return false;
      }

      const active = session.getState();

      return Boolean(
        active &&
        active.status === 'authenticated' &&
        active.profile &&
        active.profile.id === principalId
      );
    };

    const loadingMessage = jobListMessage(
      '正在讀取可接工作及我的工作…',
      'Loading available work and your work…'
    );

    clearJobLists(root, loadingMessage);
    setJobListState(root, 'loading', loadingMessage);

    try {
      const responses = await Promise.all([
        requestJson(api.available),
        requestJson(api.mine)
      ]);

      if (!isCurrent()) return;

      if (!responses.every(validJobListResponse)) {
        throw new Error('invalid_job_list_response');
      }

      renderAvailable(root, responses[0].items);
      renderMine(root, responses[1].items);

      const empty = (
        responses[0].items.length === 0 &&
        responses[1].items.length === 0
      );

      setJobListState(
        root,
        empty ? 'empty' : 'ready',
        empty
          ? jobListMessage(
              '本次查詢沒有返回可接工作或我的工作。',
              'No available work or personal work was returned.'
            )
          : jobListMessage(
              '已載入本次返回的工作。',
              'Work returned by this request is loaded.'
            )
      );
    } catch (error) {
      if (!isCurrent()) return;

      let state = 'fetch_failed';
      let message = jobListMessage(
        '工作資料讀取異常，請重試。這不代表沒有工作。',
        'Work could not be read. Retry; this does not mean no work exists.'
      );

      if (error && error.status === 401) {
        state = 'unauthorized';
        message = jobListMessage(
          '登入狀態已失效，請重新登入。',
          'Your sign-in has expired. Sign in again.'
        );
      } else if (error && error.status === 403) {
        state = 'unauthorized';
        message = jobListMessage(
          '目前沒有權限讀取這些工作，請確認 Provider 授權。',
          'You do not currently have access to this work. Check Provider authorization.'
        );
      } else if (error && error.status === 503) {
        state = 'not_connected';
        message = jobListMessage(
          '工作服務暫不可用，請稍後重試。',
          'The work service is temporarily unavailable. Retry later.'
        );
      }

      clearJobLists(root, message);
      setJobListState(root, state, message);
    }
  }

  const pendingAcceptJobs = new Set();
  const uncertainAcceptJobs = new Set();

  function acceptMessage(root, message) {
    const node = root.querySelector(
      '[data-provider-job-accept-message]'
    );

    if (node) node.textContent = message;
  }

  async function acceptJob(root, button) {
    const jobId = clean(
      button && button.getAttribute('data-provider-job-accept')
    );

    const api = endpoints(root);

    if (
      !jobId ||
      !button ||
      button.disabled ||
      pendingAcceptJobs.has(jobId)
    ) {
      return;
    }

    if (uncertainAcceptJobs.has(jobId)) {
      acceptMessage(
        root,
        jobListMessage(
          '上次接案結果尚未確認。請重新載入並核對「我的工作」，不要重複提交。',
          'The previous acceptance result is unconfirmed. Reload and check My work before submitting again.'
        )
      );
      return;
    }

    if (!api.accept || !trustedEndpoint(api.accept)) {
      acceptMessage(
        root,
        jobListMessage(
          '接案服務未連接，目前無法提交。',
          'The acceptance service is not connected.'
        )
      );
      return;
    }

    const session = nativeSession();
    const current = session && typeof session.getState === 'function'
      ? session.getState()
      : null;

    const principalId = clean(
      current && current.profile && current.profile.id
    );

    if (
      !current ||
      current.status !== 'authenticated' ||
      !principalId
    ) {
      acceptMessage(
        root,
        jobListMessage(
          '請先登入並確認 Provider 存取權限。',
          'Sign in and confirm Provider access first.'
        )
      );
      return;
    }

    const isCurrent = () => {
      if (
        !root.isConnected ||
        nativeSession() !== session
      ) {
        return false;
      }

      const active = session.getState();

      return Boolean(
        active &&
        active.status === 'authenticated' &&
        clean(active.profile && active.profile.id) === principalId
      );
    };

    const labels = copy();

    pendingAcceptJobs.add(jobId);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = labels.accepting;

    acceptMessage(
      root,
      jobListMessage(
        '正在提交接案請求，請勿重複操作。',
        'Submitting acceptance. Do not submit again.'
      )
    );

    let message = '';

    try {
      await requestJson(api.accept, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ job_id: jobId })
      });

      message = jobListMessage(
        '接案請求已獲成功回應。請核對重新載入的「我的工作」。',
        'The acceptance request returned success. Check the refreshed My work list.'
      );
    } catch (error) {
      if (error && error.status === 401) {
        message = jobListMessage(
          '登入狀態已失效。請重新登入後核對工作狀態。',
          'Your sign-in expired. Sign in again and check the work state.'
        );
      } else if (error && error.status === 403) {
        message = jobListMessage(
          '目前沒有接案權限，請確認 Provider 授權。',
          'You do not currently have acceptance permission. Check Provider authorization.'
        );
      } else if (error && error.status === 409) {
        message = jobListMessage(
          '工作狀態發生衝突，請核對最新列表；這不代表你已成功接案。',
          'The work state conflicts with this request. Check the latest lists; this does not confirm acceptance.'
        );
      } else {
        uncertainAcceptJobs.add(jobId);

        message = jobListMessage(
          '未能確認接案結果。請核對「我的工作」；本頁已阻止直接重複提交。',
          'Acceptance could not be confirmed. Check My work; direct resubmission is blocked on this page.'
        );
      }
    } finally {
      pendingAcceptJobs.delete(jobId);

      if (button.isConnected) {
        button.removeAttribute('aria-busy');
      }
    }

    if (!isCurrent()) {
      acceptMessage(root, '');
      return;
    }

    acceptMessage(root, message);

    await load(root);

    if (!isCurrent()) return;

    acceptMessage(root, message);
  }

  function loadServerDraft(root, editor, jobId, isCurrent) {
    const api = endpoints(root);

    if (!editor || !api.draft || !jobId) {
      return Promise.resolve();
    }

    const stillCurrent = () => (
      root.isConnected &&
      editor.isConnected &&
      (
        typeof isCurrent !== 'function' ||
        isCurrent()
      ) &&
      clean(
        editor.getAttribute('data-provider-report-job-id')
      ) === jobId
    );

    if (!stillCurrent()) {
      return Promise.resolve();
    }

    editorStatus(editor, 'loading', copy().saving);

    return requestJson(
      api.draft + '?job_id=' + encodeURIComponent(jobId)
    ).then((response) => {
      if (!stillCurrent()) return;

      if (response.draft) {
        draftCache.set(jobId, response.draft);
        applyDraft(editor, response.draft);

        editor.setAttribute(
          'data-provider-report-editor-state',
          'editing'
        );
      }

      editor.setAttribute(
        'data-provider-report-draft-version',
        String(response.version || 0)
      );

      editor.setAttribute(
        'data-provider-report-draft-saved-at',
        clean(response.saved_at)
      );

      setEditorLocked(
        editor,
        response.editable !== true
      );

      if (response.editable === true) {
        editorStatus(
          editor,
          'saved',
          response.saved_at
            ? copy().saved
            : copy().notSaved
        );
      }
    }).catch(() => {
      if (!stillCurrent()) return;

      if (
        editor.getAttribute(
          'data-provider-report-editor-locked'
        ) !== 'true'
      ) {
        editorStatus(
          editor,
          'error',
          copy().saveError
        );
      }
    });
  }

  function saveDraft(root, editor) {
    var api = endpoints(root);
    if (!editor || !api.draft || editor.getAttribute('data-provider-report-editor-locked') === 'true') {
      return Promise.resolve();
    }
    var jobId = clean(editor.getAttribute('data-provider-report-job-id'));
    if (!jobId) return Promise.resolve();
    var draft = captureEditor(editor) || blankDraft();
    editorStatus(editor, 'saving', copy().saving);
    return requestJson(api.draft, {
      method: 'PUT',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ job_id: jobId, draft: draft })
    }).then(function (response) {
      if (response.draft) draftCache.set(jobId, response.draft);
      editor.setAttribute('data-provider-report-draft-version', String(response.version || 0));
      editor.setAttribute('data-provider-report-draft-saved-at', clean(response.saved_at));
      editorStatus(editor, 'saved', copy().saved);
    }).catch(function (error) {
      if (error && error.status === 409) {
        setEditorLocked(editor, true);
        return;
      }
      editorStatus(editor, 'error', copy().saveError);
      throw error;
    });
  }

  function scheduleSave(root, editor) {
    var jobId = clean(editor && editor.getAttribute('data-provider-report-job-id'));
    if (!jobId || editor.getAttribute('data-provider-report-editor-locked') === 'true') return;
    captureEditor(editor);
    editorStatus(editor, 'pending', copy().saving);
    var current = saveTimers.get(jobId);
    if (current) window.clearTimeout(current);
    saveTimers.set(jobId, window.setTimeout(function () {
      saveTimers.delete(jobId);
      saveDraft(root, editor).catch(function () {});
    }, 700));
  }

  function flushEditor(root) {
    var editor = root.querySelector('[data-provider-report-editor]');
    if (!editor) return Promise.resolve();
    var jobId = clean(editor.getAttribute('data-provider-report-job-id'));
    if (!jobId) return Promise.resolve();
    var timer = saveTimers.get(jobId);
    if (timer) {
      window.clearTimeout(timer);
      saveTimers.delete(jobId);
    }
    if (editor.getAttribute('data-provider-report-editor-locked') === 'true') return Promise.resolve();
    return saveDraft(root, editor);
  }

  function setSubmitState(root, jobStatus, message) {
    var preview = root.querySelector('[data-provider-report-preview]');
    if (!preview) return;
    var labels = copy();
    var button = preview.querySelector('[data-provider-report-submit-action]');
    var status = preview.querySelector('[data-provider-report-submit-status]');
    var normalized = clean(jobStatus);
    preview.setAttribute('data-provider-report-submit-state', normalized === 'in_review' ? 'submitted' : 'idle');
    if (!button) return;
    if (normalized === 'in_review') {
      button.disabled = true;
      button.textContent = labels.submitted;
      if (status) status.textContent = labels.submittedStatus;
      return;
    }
    button.textContent = labels.submit;
    button.disabled = normalized !== 'assigned' || preview.getAttribute('data-provider-report-preview-state') !== 'ready';
    if (status) status.textContent = clean(message);
  }

  function resetPreview(root) {
    var preview = root.querySelector('[data-provider-report-preview]');
    if (!preview) return;
    preview.setAttribute('data-provider-report-preview-state', 'idle');
    var status = preview.querySelector('[data-provider-report-preview-status]');
    if (status) status.textContent = '';
    var frame = preview.querySelector('[data-provider-report-preview-frame]');
    if (frame) frame.removeAttribute('srcdoc');
    var editor = root.querySelector('[data-provider-report-editor]');
    setSubmitState(root, editor && editor.getAttribute('data-provider-report-job-status'), '');
  }

  function previewReport(root, button) {
    var api = endpoints(root);
    var editor = root.querySelector('[data-provider-report-editor]');
    var preview = root.querySelector('[data-provider-report-preview]');
    var frame = preview && preview.querySelector('[data-provider-report-preview-frame]');
    var status = preview && preview.querySelector('[data-provider-report-preview-status]');
    var jobId = clean(editor && editor.getAttribute('data-provider-report-job-id'));
    if (!api.preview || !preview || !frame || !jobId || !button || button.disabled) return;
    var labels = copy();
    button.disabled = true;
    button.textContent = labels.previewing;
    preview.setAttribute('data-provider-report-preview-state', 'loading');
    setSubmitState(root, editor && editor.getAttribute('data-provider-report-job-status'), '');
    if (status) status.textContent = labels.previewing;
    flushEditor(root).then(function () {
      var locale = clean(document.documentElement.lang) || 'en';
      return requestJson(api.preview + '?job_id=' + encodeURIComponent(jobId) + '&locale=' + encodeURIComponent(locale));
    }).then(function (response) {
      frame.srcdoc = String(response.html || '');
      preview.setAttribute('data-provider-report-preview-state', 'ready');
      preview.setAttribute('data-provider-report-preview-version', String(response.draft_version || 0));
      if (status) status.textContent = labels.previewReady;
      setSubmitState(root, editor && editor.getAttribute('data-provider-report-job-status'), '');
    }).catch(function () {
      preview.setAttribute('data-provider-report-preview-state', 'error');
      if (status) status.textContent = labels.previewError;
      setSubmitState(root, editor && editor.getAttribute('data-provider-report-job-status'), '');
    }).then(function () {
      button.disabled = false;
      button.textContent = labels.preview;
    });
  }

  function submitReport(root, button) {
    var api = endpoints(root);
    var editor = root.querySelector('[data-provider-report-editor]');
    var preview = root.querySelector('[data-provider-report-preview]');
    var submitStatus = preview && preview.querySelector('[data-provider-report-submit-status]');
    var jobId = clean(editor && editor.getAttribute('data-provider-report-job-id'));
    var jobStatus = clean(editor && editor.getAttribute('data-provider-report-job-status'));
    if (!api.submit || !preview || !jobId || !button || button.disabled) return;
    if (jobStatus !== 'assigned' || preview.getAttribute('data-provider-report-preview-state') !== 'ready') return;

    var labels = copy();
    button.disabled = true;
    button.textContent = labels.submitting;
    preview.setAttribute('data-provider-report-submit-state', 'submitting');
    if (submitStatus) submitStatus.textContent = labels.submitting;

    requestJson(api.submit, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ job_id: jobId })
    }).then(function (response) {
      editor.setAttribute('data-provider-report-job-status', 'in_review');
      editor.setAttribute('data-provider-report-draft-version', String(response.draft_version || editor.getAttribute('data-provider-report-draft-version') || 0));
      setEditorLocked(editor, true);
      var detailStatus = root.querySelector('[data-provider-job-detail-status]');
      if (detailStatus) detailStatus.textContent = statusLabel('in_review');
      setSubmitState(root, 'in_review', labels.submittedStatus);
      return load(root);
    }).catch(function (error) {
      preview.setAttribute('data-provider-report-submit-state', 'error');
      button.disabled = false;
      button.textContent = labels.submit;
      if (submitStatus) {
        submitStatus.textContent = error && error.code === 'report_draft_incomplete'
          ? labels.summaryRequired
          : labels.submitError;
      }
    });
  }

  function closeDetail(root) {
    flushEditor(root).catch(function () {});
    var dialog = root.querySelector('[data-provider-job-detail]');
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
  }

  function renderDetail(root, job, isCurrent) {
    var dialog = root.querySelector('[data-provider-job-detail]');
    if (!dialog) return;
    var title = dialog.querySelector('[data-provider-job-detail-title]');
    var status = dialog.querySelector('[data-provider-job-detail-status]');
    if (title) title.textContent = formatProduct(job && job.product_handle);
    if (status) status.textContent = statusLabel(job && job.status);
    renderDetailValue(dialog.querySelector('[data-provider-job-detail-field="property_context"]'), job && job.property_context);
    renderDetailValue(dialog.querySelector('[data-provider-job-detail-field="customer_requirement"]'), job && job.customer_requirement);
    renderDetailValue(dialog.querySelector('[data-provider-job-detail-field="source_data"]'), job && job.source_data);
    renderDetailValue(dialog.querySelector('[data-provider-job-detail-field="missing_evidence"]'), job && job.missing_evidence);
    var deadline = dialog.querySelector('[data-provider-job-detail-field="deadline"]');
    if (deadline) deadline.textContent = formatDeadline(job && job.deadline);
    var editor = dialog.querySelector('[data-provider-report-editor]');
    hydrateEditor(editor, job && job.job_id, job && job.status);
    resetPreview(root);
    setSubmitState(root, job && job.status, '');
    loadServerDraft(root, editor, clean(job && job.job_id), isCurrent);
  }

  const detailReadVersions = new WeakMap();

  function detailReadState(root, state, text) {
    const dialog = root.querySelector('[data-provider-job-detail]');
    if (!dialog) return;

    dialog.setAttribute('data-provider-job-detail-state', state);
    dialog.setAttribute('aria-busy', String(state === 'loading'));

    const message = dialog.querySelector(
      '[data-provider-job-detail-message]'
    );
    const retry = dialog.querySelector(
      '[data-provider-job-detail-retry]'
    );

    if (message) message.textContent = text;

    if (retry) {
      retry.hidden = state === 'loading' || state === 'ready';
      retry.disabled = state === 'loading';
    }

    if (state !== 'ready') {
      const title = dialog.querySelector(
        '[data-provider-job-detail-title]'
      );
      const status = dialog.querySelector(
        '[data-provider-job-detail-status]'
      );

      if (title) {
        title.textContent = jobListMessage('工作詳情', 'Work details');
      }

      if (status) {
        status.textContent = state === 'loading'
          ? jobListMessage('正在載入', 'Loading')
          : jobListMessage('尚未載入', 'Not loaded');
      }
    }
  }

  async function openDetail(root, jobId) {
    const api = endpoints(root);
    const dialog = root.querySelector('[data-provider-job-detail]');
    const requestedId = clean(jobId);

    if (!dialog || !requestedId) return;

    const version = (detailReadVersions.get(root) || 0) + 1;
    detailReadVersions.set(root, version);
    dialog.setAttribute('data-provider-detail-requested-id', requestedId);

    if (!dialog.open && typeof dialog.showModal === 'function') {
      dialog.showModal();
    }

    if (dialog.dataset.detailCloseBound !== 'true') {
      dialog.dataset.detailCloseBound = 'true';

      dialog.addEventListener('close', () => {
        detailReadVersions.set(
          root,
          (detailReadVersions.get(root) || 0) + 1
        );
      });
    }

    const session = nativeSession();
    const current = session && typeof session.getState === 'function'
      ? session.getState()
      : null;
    const principalId = clean(
      current && current.profile && current.profile.id
    );

    if (
      !current ||
      current.status !== 'authenticated' ||
      !principalId
    ) {
      detailReadState(
        root,
        'unauthorized',
        jobListMessage(
          '請登入並確認工作存取權限。',
          'Sign in and confirm access to this work.'
        )
      );
      return;
    }

    if (!api.detail || !trustedEndpoint(api.detail)) {
      detailReadState(
        root,
        'not_connected',
        jobListMessage(
          '工作詳情服務未連接。',
          'The work detail service is not connected.'
        )
      );
      return;
    }

    const isCurrent = () => {
      if (
        !root.isConnected ||
        !dialog.open ||
        detailReadVersions.get(root) !== version ||
        nativeSession() !== session
      ) {
        return false;
      }

      const active = session.getState();

      return Boolean(
        active &&
        active.status === 'authenticated' &&
        clean(active.profile && active.profile.id) === principalId
      );
    };

    detailReadState(
      root,
      'loading',
      jobListMessage('正在讀取工作詳情…', 'Loading work details…')
    );

    try {
      const url = new URL(api.detail);
      url.searchParams.set('job_id', requestedId);

      const response = await requestJson(url.toString());

      if (!isCurrent()) return;

      const job = response.job;

      if (
        !job ||
        typeof job !== 'object' ||
        Array.isArray(job) ||
        typeof job.job_id !== 'string' ||
        job.job_id.trim() !== requestedId ||
        typeof job.status !== 'string' ||
        !job.status.trim()
      ) {
        throw new Error('invalid_job_detail_response');
      }

      renderDetail(root, job, isCurrent);
      detailReadState(root, 'ready', '');
    } catch (error) {
      if (!isCurrent()) return;

      let state = 'fetch_failed';
      let message = jobListMessage(
        '工作詳情讀取異常，請重試。',
        'Work details could not be read. Retry.'
      );

      if (error && error.status === 401) {
        state = 'unauthorized';
        message = jobListMessage(
          '登入狀態已失效，請重新登入。',
          'Your sign-in expired. Sign in again.'
        );
      } else if (error && error.status === 403) {
        state = 'unauthorized';
        message = jobListMessage(
          '目前沒有權限查看這份工作。',
          'You do not currently have access to this work.'
        );
      } else if (error && error.status === 404) {
        message = jobListMessage(
          '未能取得指定工作，請返回列表核對。',
          'The requested work could not be retrieved. Check the list.'
        );
      } else if (error && error.status === 503) {
        state = 'not_connected';
        message = jobListMessage(
          '工作服務暫不可用，請稍後重試。',
          'The work service is temporarily unavailable. Retry later.'
        );
      }

      detailReadState(root, state, message);
    }
  }

  function mount(root) {
    if (!root || root.getAttribute('data-provider-jobs-runtime') === VERSION) return;
    root.setAttribute('data-provider-jobs-runtime', VERSION);
    root.addEventListener('click', function (event) {
      const retry = event.target && event.target.closest
        ? event.target.closest('[data-provider-jobs-retry]')
        : null;

      if (retry && root.contains(retry)) {
        event.preventDefault();

        if (!retry.disabled) {
          void load(root);
        }

        return;
      }

      var accept = event.target && event.target.closest ? event.target.closest('[data-provider-job-accept]') : null;
      if (accept && root.contains(accept)) {
        event.preventDefault();
        acceptJob(root, accept);
        return;
      }
      const detailRetry = event.target && event.target.closest
        ? event.target.closest('[data-provider-job-detail-retry]')
        : null;

      if (detailRetry && root.contains(detailRetry)) {
        event.preventDefault();

        const detailDialog = root.querySelector(
          '[data-provider-job-detail]'
        );
        const requestedId = clean(
          detailDialog &&
          detailDialog.getAttribute('data-provider-detail-requested-id')
        );

        if (!detailRetry.disabled && requestedId) {
          void openDetail(root, requestedId);
        }

        return;
      }

      var open = event.target && event.target.closest ? event.target.closest('[data-provider-job-open]') : null;
      if (open && root.contains(open)) {
        event.preventDefault();
        openDetail(root, clean(open.getAttribute('data-provider-job-open')));
        return;
      }
      var preview = event.target && event.target.closest ? event.target.closest('[data-provider-report-preview-action]') : null;
      if (preview && root.contains(preview)) {
        event.preventDefault();
        previewReport(root, preview);
        return;
      }
      var submit = event.target && event.target.closest ? event.target.closest('[data-provider-report-submit-action]') : null;
      if (submit && root.contains(submit)) {
        event.preventDefault();
        submitReport(root, submit);
        return;
      }
      var close = event.target && event.target.closest ? event.target.closest('[data-provider-job-detail-close]') : null;
      if (close && root.contains(close)) {
        event.preventDefault();
        closeDetail(root);
      }
    });
    root.addEventListener('input', function (event) {
      var field = event.target && event.target.closest ? event.target.closest('[data-provider-report-field]') : null;
      if (!field || !root.contains(field)) return;
      resetPreview(root);
      scheduleSave(root, field.closest('[data-provider-report-editor]'));
    });
    var dialog = root.querySelector('[data-provider-job-detail]');
    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDetail(root);
      });
    }
    void load(root);
  }

  function mountAll(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    if (base.matches && base.matches(ROOT_SELECTOR)) mount(base);
    Array.prototype.forEach.call(base.querySelectorAll(ROOT_SELECTOR), mount);
  }

  var api = Object.freeze({
    version: VERSION,
    draftContract: REPORT_DRAFT_CONTRACT,
    mountAll: mountAll,
    getDraft: function (jobId) {
      return draftCache.get(clean(jobId)) || null;
    },
    refresh: function () {
      Array.prototype.forEach.call(document.querySelectorAll(ROOT_SELECTOR), function (root) {
        if (nativeReady()) load(root);
      });
    }
  });
  window[GLOBAL_KEY] = api;
  window.ProviderReportJobs = api;

  document.addEventListener('littleg:web-session-change', function () {
    const signedIn = nativeReady();

    const message = signedIn
      ? jobListMessage(
          '登入資料已更新，正在重新確認工作。',
          'Sign-in information changed. Rechecking work.'
        )
      : jobListMessage(
          '請登入並確認 Provider 存取權限。',
          'Sign in and confirm Provider access.'
        );

    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      resetJobLists(
        root,
        signedIn ? 'not_connected' : 'unauthorized',
        message
      );
    });

    mountAll(document);

    if (signedIn) {
      api.refresh();
    }
  });
  document.addEventListener('shopify:section:load', function (event) {
    mountAll(event.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountAll(document); }, { once: true });
  } else {
    mountAll(document);
  }
})(window, document);
